import { IApiDataType } from '../types'
import { api as arbApi, configs as arbConfigs } from './arb'
import { api as bbbApi, configs as bbbConfigs } from './bbb'
import {
  api as burgerworksApi,
  configs as burgerworksConfigs,
} from './burgerworks'
import { api as commonApi, configs as commonConfigs } from './common'
import { api as dhWbApi, configs as dhWbConfigs } from './dhWb'
import {
  api as fwWingstopApi,
  configs as fwWingstopConfigs,
} from './fw_wingstop'
import { api as lfrApi, configs as lfrConfigs } from './lfr'
import {
  api as wingitnorthApi,
  configs as wingitnorthConfigs,
} from './wingitnorth'

export type IApiKeyType = keyof typeof api

export const configs = {
  ...commonConfigs,
  ...burgerworksConfigs,
  ...fwWingstopConfigs,
  ...dhWbConfigs,
  ...arbConfigs,
  ...lfrConfigs,
  ...bbbConfigs,
  ...wingitnorthConfigs,
}

const api = {
  ...commonApi,
  ...burgerworksApi,
  ...fwWingstopApi,
  ...dhWbApi,
  ...arbApi,
  ...lfrApi,
  ...bbbApi,
  ...wingitnorthApi,
}

const useApi = (
  apiName: IApiKeyType,
): { data: IApiDataType; loading: boolean } => api[apiName]()

export default useApi
